/*
 * shipping-estimate.js
 * 商品ページの発送予定テキストを、のし包装／名入れ（Infinite Options アプリの select）の
 * 選択状態に応じて出し分ける。第1段階: 実日付計算なし・固定文言のみ。
 *
 * 判定:
 *   名入れあり              → data-text-naire   (data-shipping-type="naire")
 *   名入れなし・のし包装あり → data-text-gift    (data-shipping-type="gift")
 *   どちらもなし            → data-text-default (data-shipping-type="default")
 *
 * Infinite Options の select はアプリがクライアント側で後から注入し、バリアント変更で
 * 再描画されることがあるため、(1)初期ポーリング (2)MutationObserver (3)change イベント委譲
 * の3系統で更新する。select の name はオプション名（商品ごと）に依存するため、name に
 * 含まれるキーワードでマッチする（"名入" / "のし"・"ギフト"・"包装"）。
 */
(function () {
  if (window.__shippingEstimateInit) return;
  window.__shippingEstimateInit = true;

  var NONE_VALUES = ['', 'なし', '選択してください', '選択しない'];

  function isSelected(sel) {
    if (!sel) return false;
    var v = (sel.value || '').trim();
    return NONE_VALUES.indexOf(v) === -1;
  }

  function findSelect(scope, keywords) {
    var selects = scope.querySelectorAll('select[name^="properties["]');
    for (var i = 0; i < selects.length; i++) {
      var name = selects[i].getAttribute('name') || '';
      for (var k = 0; k < keywords.length; k++) {
        if (name.indexOf(keywords[k]) !== -1) return selects[i];
      }
    }
    return null;
  }

  function applyPosition(container, scope) {
    if (container.dataset.positioned === 'done') return;
    var pos = container.getAttribute('data-position') || 'above_atc';
    var buy = scope.querySelector('.product-form__buy-buttons');
    if (!buy || !buy.parentNode) return; // buy-buttons 未描画なら後で再試行
    if (pos === 'below_atc') {
      if (buy.nextSibling !== container) {
        buy.parentNode.insertBefore(container, buy.nextSibling);
      }
    } else {
      // above_atc（既定）: buy-buttons の直前に置く
      if (buy.previousElementSibling !== container) {
        buy.parentNode.insertBefore(container, buy);
      }
    }
    container.dataset.positioned = 'done';
  }

  function updateOne(container) {
    var scope = container.closest('.product-form') || document;
    var naireSel = findSelect(scope, ['名入']);
    var giftSel = findSelect(scope, ['のし', 'ギフト', '包装']);

    var type, text;
    if (isSelected(naireSel)) {
      type = 'naire';
      text = container.getAttribute('data-text-naire');
    } else if (isSelected(giftSel)) {
      type = 'gift';
      text = container.getAttribute('data-text-gift');
    } else {
      type = 'default';
      text = container.getAttribute('data-text-default');
    }

    var main = container.querySelector('[data-shipping-estimate-main]');
    if (main && typeof text === 'string' && main.textContent !== text) {
      main.textContent = text;
    }
    container.setAttribute('data-shipping-type', type);

    applyPosition(container, scope === document ? document : scope);
  }

  function updateAll() {
    var containers = document.querySelectorAll('[data-shipping-estimate]');
    for (var i = 0; i < containers.length; i++) updateOne(containers[i]);
  }

  // デバウンス
  var raf = null;
  function scheduleUpdate() {
    if (raf) return;
    raf = window.requestAnimationFrame(function () {
      raf = null;
      updateAll();
    });
  }

  // (3) 選択変更を委譲で検知（select が再描画されても効く）
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t && t.matches && t.matches('select[name^="properties["]')) scheduleUpdate();
  }, true);

  // (2) MutationObserver: アプリの注入・再描画を検知
  function startObserver() {
    if (!window.MutationObserver) return;
    var mo = new MutationObserver(function () { scheduleUpdate(); });
    mo.observe(document.body, { childList: true, subtree: true });
  }

  // (1) 初期ポーリング: Infinite Options が読み込まれるまで数回更新
  function init() {
    updateAll();
    startObserver();
    var tries = 0;
    var iv = setInterval(function () {
      updateAll();
      if (++tries >= 20) clearInterval(iv); // 約10秒
    }, 500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
